import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const NuevoServiceRequest = React.lazy(
  () => import("../screean/services/nuevo-Service-Request")
);
export function nuevoServiceRequest() {
  return (
    <Route
      path="/nuevo-service-request"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <NuevoServiceRequest />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
